/* @flow */

import React from 'react';

// import classes from './Circle.scss';

type PropsType = {};
type StateType = {};

export class Circle extends React.PureComponent<PropsType, *> {
  static defaultProps = {};

  state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    return (
      <circle {...this.props} />
    );
  }
}

export default Circle;



// WEBPACK FOOTER //
// ./src/components/Circle/Circle.js